import { createSelector } from 'reselect';
import { addHighlightPillsSelector } from 'selectors/testTarget/offers/addHighlightPills/addHighlightPillsSelector';

const experienceSelector = createSelector(addHighlightPillsSelector, addHighlightPills => addHighlightPills.experience);

export { experienceSelector };
